<template>
  <div class="grid-view">
    <div class="main-content accounting-documents-rule">
      <div class="section operations">
        <div class="filters">
          <span v-if="!locked">
            <el-button type="primary" @click="saveHandler">{{ $t('common.btn.save') }}</el-button>
            <el-button type="primary" @click="cancelHandler">{{ $t('common.btn.cancel') }}</el-button>
          </span>
          <span v-else>
            <el-button type="primary" @click="addHandler">{{ $t('common.btn.new') }}</el-button>
            <el-button :disabled="!cellSelected" type="primary" @click="editHandler">{{ $t('common.btn.edit') }}</el-button>
            <el-button :disabled="!cellSelected" type="danger" @click="removeHandler">{{ $t('common.btn.delete') }}</el-button>
          </span>
        </div>
      </div>
      <div class="section grid-wrapper">
        <cargo-ag-grid
          config-module="1002002"
          :show-side-bar="false"
          :grid-params.sync="gridParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          style="min-height: 500px;width:100%"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CargoAgGridSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor'
import { getLoading } from '@/utils/utilBaseElement'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor/index.vue'
import CargoAgGridCommonTextareaEditor from '@/components/Cargo/Common/CargoAgGridCommonTextareaEditor/index.vue'
import CargoAgGridAdvanceMultipleSelectEditor
  from '@/components/Cargo/Common/CargoAgGridAdvanceMultipleSelectEditor/index.vue'
import {
  queryReleaseGuaranteeList,
  removeReleaseGuarantee,
  saveReleaseGuarantee
} from '@/api/sysManage/baseConfig/putASingleRule'
import { getCacheListByKey } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import * as BlModeType from '@/class/cargo/model/parameters/BlModeType'

export default {
  name: 'ReleaseGuaranteeSetting',
  data() {
    return {
      cellSelected: false, // 是否选中行
      gridParams: {},
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        suppressRowClickSelection: true,
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false,
        // 单击显示编辑
        singleClickEdit: true,
        // 添加编辑组件
        frameworkComponents: {
          CargoAgGridSelectEditor,
          CargoAgGridCommonInputEditor,
          CargoAgGridCommonTextareaEditor,
          CargoAgGridAdvanceMultipleSelectEditor
        },
        onRowClicked: (event) => {
          this.cellSelected = true
          this.selectedItem = event.data
        }
      },
      rowData: [],
      locked: true,
      selectedItem: null, // 表格选中项
      hblTeleReleaseGuaranteeSelectdArray: [
        {
          name: this.$t('CargoMsg.Cargo_Enable'),
          value: true
        },
        {
          name: this.$t('CargoMsg.Cargo_Disable'),
          value: false
        }
      ],
      teleReleaseBillType: [
        { serialNumber: 1, code: 'ORIGINAL', name: 'ORIGINAL', localName: this.$t('SeaExport.OriginalNormal') },
        { serialNumber: 2, code: 'SURRENDERED', name: 'SURRENDERED', localName: this.$t('SeaExport.TelexRelease') },
        { serialNumber: 3, code: 'SEA WAYBILL', name: 'SEA WAYBILL', localName: this.$t('SeaExport.TelexRelease') }
      ]
    }
  },
  computed: {
    columnDefs() {
      return [
        {
          headerName: this.$t('CargoMsg.Cargo_OperationOffice'),
          field: 'branchId',
          colId: 'branchId',
          width: 400,
          editable: !this.locked,
          cellEditor: 'CargoAgGridAdvanceMultipleSelectEditor',
          cellEditorParams: {
            selectProps: {
              staticOptions: ColumnUtils.getBasicDataCacheList(TYPE_NAMES.basic_data_Office),
              tagName: this.$store.getters.isZh ? 'chineseName' : 'englishName',
              tagValue: 'officeId',
              filterable: true,
              clearable: true,
              multiple: true,
              showCustomLabelInOption: true
            }
          },
          // 值变化事件
          onCellValueChanged: (params) => {
            this.onCellChange(params)
          },
          cellRenderer: (params) => {
            return ColumnUtils.resolveMultipleColumnLabelByCustom(ColumnUtils.getBasicDataCacheList(TYPE_NAMES.basic_data_Office), 'officeId', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_HblTeleReleaseGuarantee'),
          field: 'status',
          colId: 'status',
          width: 200,
          editable: !this.locked,
          cellEditor: 'CargoAgGridSelectEditor',
          cellEditorParams: {
            selectProps: {
              staticOptions: this.hblTeleReleaseGuaranteeSelectdArray,
              tagName: 'name',
              tagValue: 'value',
              showCustomLabelInOption: true
            }
          },
          // 值变化事件
          onCellValueChanged: (params) => {
            this.onCellChange(params)
          },
          valueFormatter: params => {
            return ColumnUtils.enableStatusLabelFunction(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_TeleReleaseBillType'),
          field: 'teleReleaseBillType',
          colId: 'teleReleaseBillType',
          width: 400,
          editable: !this.locked,
          cellEditor: 'CargoAgGridAdvanceMultipleSelectEditor',
          cellEditorParams: {
            selectProps: {
              staticOptions: this.teleReleaseBillType,
              tagName: 'name',
              tagValue: 'serialNumber',
              filterable: true,
              clearable: true,
              multiple: true,
              showCustomLabelInOption: true
            }
          },
          // 值变化事件
          onCellValueChanged: (params) => {
            this.onCellChange(params)
          },
          cellRenderer: (params) => {
            // 转为数组
            return ColumnUtils.resolveMultipleColumnLabelByCustom(this.teleReleaseBillType, 'serialNumber', params.value, 'name')
          }
        }
      ]
    }
  },
  created() {
    this.initData()
    this.loadData()
  },
  methods: {
    addHandler() {
      this.locked = false
      const releaseGuarantee = {}
      releaseGuarantee.status = null
      releaseGuarantee.waitDealStatus = 'add'
      this.rowData.push(releaseGuarantee)

      this.gridOptions.api.refreshCells({ force: true })
    },
    editHandler() {
      if (this.rowData && this.rowData.length > 0) {
        this.locked = false
      }
    },
    saveHandler() {
      const saveList = []
      for (const row of this.rowData) {
        if (['add', 'edit'].includes(row.waitDealStatus)) {
          saveList.push(row)
        }
      }
      if (saveList.length) {
        // 校验
        for (const item of saveList) {
          if (!item.status) {
            item.status = false
          }
          if (!item.branchId || !item.branchId.length) {
            this.$message.info(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('CargoMsg.Cargo_OperationOffice'))
            return
          }
          if (!item.teleReleaseBillType || !item.teleReleaseBillType.length) {
            this.$message.info(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('CargoMsg.Cargo_TeleReleaseBillType'))
            return
          }
          item.branchId = Array.isArray(item.branchId) ? item.branchId.join(',') : item.branchId
          item.teleReleaseBillType = Array.isArray(item.teleReleaseBillType) ? item.teleReleaseBillType.join(',') : item.teleReleaseBillType
        }
        // 保存
        const loading = getLoading()
        saveReleaseGuarantee(saveList).then(resp => {
          if (resp.data) {
            this.$message.success(this.$t('CargoMsg.Cargo_SaveSucceed'))
            // this.saveSuccess(resp)
            this.loadData()
          } else {
            this.$message.success(this.$t('CargoMsg.Cargo_SaveFailed'))
          }
        }).finally(() => loading.close())
      } else {
        this.$message.warning(this.$t('CargoMsg.Cargo_NoDataModifiedNoNeedToSave'))
      }
      this.locked = true
    },
    cancelHandler() {
      this.locked = true
      this.loadData()
    },
    initData() {
      // 处理 teleReleaseBillType 选项
      const orderFormTypeList = getCacheListByKey(basicCacheKeys.basic_data_BlMode)
      // 检查 orderFormTypeList 是否为非空数组
      if (Array.isArray(orderFormTypeList) && orderFormTypeList.length) {
        // this.teleReleaseBillType
        const codes = this.teleReleaseBillType.map(item => item.code)

        // 过滤出 blType = 3 的数据
        const filteredData = orderFormTypeList.filter(item => item.blType === BlModeType.HBL.code && !codes.includes(item.code))

        // 合并 teleReleaseBillType 和 filteredData
        this.teleReleaseBillType = [...this.teleReleaseBillType, ...filteredData]
      }
    },
    loadData() {
      // 先初始化数据
      this.rowData = []
      this.cellSelected = false
      this.selectedItem = null
      const loading = getLoading()
      queryReleaseGuaranteeList().then(resp => {
        this.rowData = resp.data.map(item => {
          // 将branchId转换为数值数组，如果为空或null，则返回空数组
          item.branchId = item.branchId ? item.branchId.split(',').map(Number) : []

          // 将teleReleaseBillType转换为数值数组，如果为空或null，则返回空数组
          item.teleReleaseBillType = item.teleReleaseBillType ? item.teleReleaseBillType.split(',').map(Number) : []

          return item
        })
        this.gridOptions.api.refreshCells({ force: true })
      }).finally(() => loading.close())
    },
    async removeHandler() {
      const cell = this.gridOptions.api.getFocusedCell()
      const currentRow = cell ? this.selectedItem : null
      if (!currentRow) {
        this.$message.error(this.$t('common.tips.hasOneAtleast'))
        return
      }
      await this.$confirm(this.$t('CargoMsg.Cargo_SureToDelete'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        canCloseModule: true
      })
      const loading = getLoading()
      removeReleaseGuarantee([currentRow.uuid]).then(resp => {
        if (resp.data) {
          this.removeSuccess(currentRow.uuid)
        } else {
          this.$message.warning(this.$t('Message.DeleteFailed'))
        }
      }).finally(() => loading.close())
    },
    onCellChange(params) {
      const { node } = params
      if (node.data.uuid) {
        node.data.waitDealStatus = 'edit'
      }
    },
    saveSuccess(resp) {
      // 返回的列表中可能同时含有编辑的和新增的数据
      const list = resp.data
      if (!list || list.length === 0) {
        return
      }
      // 1 遍历rowData列表能匹配到uuid的数据（编辑的数据），更新数据
      for (let i = 0; i < this.rowData.length; i++) {
        const row = this.rowData[i]
        if (row.uuid) {
          const index = list.findIndex(params => params.uuid === row.uuid)
          if (index > -1) {
            Object.assign(row, list[index])
            list.splice(index, 1)
          }
          row.waitDealStatus = ''
        }
      }
      // 2 遍历rowData列表中没有uuid的数据 删除该数据
      for (let i = this.rowData.length - 1; i >= 0; i--) {
        if (!this.rowData[i].uuid) {
          this.rowData.splice(i, 1)
        }
      }
      // 3 添加列表里没有匹配uuid的数据（新增的数据）到列表
      this.rowData.push(...list)
      this.gridOptions.api.refreshCells({ force: true })
    },
    removeSuccess(uuid) {
      const index = this.rowData.findIndex(params => params.uuid === uuid)
      if (index > -1) {
        this.rowData.splice(index, 1)
        this.gridOptions.api.refreshCells({ force: true })
      }
      this.$message.success(this.$t('Message.DeleteSuccessfully'))
    }
  }
}
</script>

<style scoped>

</style>
